import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "a4a6f8fa-193d-4e8a-bba7-6e71fca321ea",
    content: "The number of frequency points of DFT is always the same<br>than the one of the original signal",
    options: {},
  },
  {
    id: "c96718ad-2e0c-45e4-aa3c-8cf1901c4031",
    content: "Replicas do not overlap if the sampling frequency is equal<br>to the maximum frequency of the CT signal",
    options: {},
  },
  {
    id: "291d05f5-2848-4707-9871-bf0d092bac1d",
    content:
      "Contrary to CT system, the impulse response of a DT<br>system can have non zero values for negative values of $n$",
    options: {},
  },
  { id: "d69ebdde-e1c6-4273-86aa-72d6bb74f302", content: "An anti-aliasing filter is low-pass", options: {} },
  {
    id: "09929820-2619-48e2-b4f0-6cb41ad52966",
    content: "FFT can be directly applied<br>to any DT signal",
    options: {},
  },
  {
    id: "cb69a463-3d67-4be5-a322-9de4443bb41d",
    content: "Convolution in the time domain corresponds to a product<br>in the frequency domain",
    options: {},
  },
];

export const task: Task = {
  id: "4dbd52cb-8480-45db-9728-8321183a9c92",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["d69ebdde-e1c6-4273-86aa-72d6bb74f302", "cb69a463-3d67-4be5-a322-9de4443bb41d"],
};
